import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // You could send error + info to a logging service here
        // Keep it minimal and safe for production
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught an error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="error-boundary" style={{ padding: '24px', background: '#fff5f5', color: '#611a15', borderRadius: 8 }}>
                    <h3>Something went wrong</h3>
                    <p>We're having trouble showing this step. Please try again or contact your administrator.</p>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {String(this.state.error)}
                    </details>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
